import initAboutSlider from "./init-about-slider";
import initBarriersSlider from "./init-barriers-slider";
import initCareerSlider from "./init-career-slider";
import initCasesSlider from "./init-cases-slider";
import initDiplomSlider from "./init-diplom-slider";
import initLicenseSlider from "./init-license-slider";
import initPartnersSlider from "./init-partners-slider";
import initPlatformSlider from "./init-platform-slider";
import initPopularSlider from "./init-popular-slider";
import initTalkSlider from "./init-talk-slider";
import initTeachersMainSlider from "./init-teachers-main-slider";
import initTeachersCareerSlider from "./init-teachers-career-slider";
import initTeamSlider from "./init-team-slider";
import initWorthSlider from "./init-worth-slider";
import initBecomeSlider from "./init-become-slider";
import initCoachesSlider from "./init-coaches-slider";
import initFormatsSlider from "./init-formats-slider";
import initTrainingSlider from "./init-training-slider";
import initSuccessSlider from "./init-success-slider";

const sliders = () => {
  initTeachersMainSlider();
  initTeachersCareerSlider();
  initCasesSlider();
  initDiplomSlider();
  initWorthSlider();
  initTalkSlider();
  initTeamSlider();
  initAboutSlider();
  initPlatformSlider();
  initBarriersSlider();
  initCareerSlider();
  initLicenseSlider();
  initPartnersSlider();
  initPopularSlider();
  initBecomeSlider(1);
  initBecomeSlider(2);
  initCoachesSlider();
  initFormatsSlider();
  initTrainingSlider();
  initSuccessSlider();
};

export default sliders;
